import requester, { IRequesterResponse } from '@/utils/requester';

const FileServices = {
  async post(data: { key?: string; file: File }) {
    const formData = new FormData();
    formData.append('key', data.key || 'avatar:test');
    formData.append('file', data.file);

    const result: IRequesterResponse = await requester.post(`/file/v1/files`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return result;
  },
};

export default FileServices;
